import React, { useState, useEffect } from "react";

function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookieConsent");
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem("cookieConsent", "true");
        setVisible(false);
    };

    const showCookiesPolicy = () => {
        document.getElementById('cookiePolicyDiv').style.display = 'block';
        window.scrollTo(0, document.body.scrollHeight);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner">
            <p>
                Questo sito non utilizza cookie propri, ma solo quelli di terze parti
                legati a Google Maps. Continuando la navigazione accetti la nostra
                <button onClick={showCookiesPolicy} className="btn btn-primary btn-sm left-margin-5">
                    Cookie Policy
                </button>
            </p>
            <button onClick={acceptCookies} className="btn btn-primary btn-sm">
                Accetto
            </button>
        </div>
    );
}

export default CookieBanner;
